/**
 * Role constants for user management UI.
 *
 * Domain classification (ASSIGNABLE_ROLES, NON_ASSIGNABLE_ROLES) from @insio/shared-types.
 * UI display helpers (MEMBER_ROLE, getDisplayRoles, getSingleRoleBadgeColor) from @insio/ui-toolkit.
 * Only `parseAssignableRoles` is app-specific (handles Select component values).
 */
export {
  ASSIGNABLE_ROLES,
  KEY_ASSIGNABLE_ROLES,
  NON_ASSIGNABLE_ROLES,
  type AssignableRole,
  type NonAssignableRole,
  isNonAssignableRole,
  getNonAssignableRoles,
  getAssignableRoles
} from '@insio/shared-types';

export {
  MEMBER_ROLE,
  SELECTABLE_ROLES,
  type SelectableRole,
  isSelectableRole,
  toSelectableRole,
  getDisplayRole,
  getDisplayRoles,
  getSingleRoleBadgeColor
} from '@insio/ui-toolkit';

import { ASSIGNABLE_ROLES, type AssignableRole } from '@insio/shared-types';

/**
 * Parse a Select onChange value into an array of assignable roles.
 * Handles both single and multi-select return types from `@insio/ui-toolkit` Select.
 */
export function parseAssignableRoles(
  value: string | number | (string | number)[]
): AssignableRole[] {
  const values = Array.isArray(value) ? value : [value];
  return values.filter(
    (r): r is AssignableRole =>
      typeof r === 'string' && (ASSIGNABLE_ROLES as readonly string[]).includes(r)
  );
}
